<ul class="sh-form-check-list" [id]="id" [ngClass]="{ '-sh-inline': inline }">
  @for (option of selectOptions$ | async; track option; let index = $index) {
    <li
      class="sh-form-check sh-form-check-list__item"
      [title]="option | getDisabledMsg: disabledMsg"
      >
      <input
        #optionElements
        type="checkbox"
        [tabindex]="index === focusIndex ? 0 : -1"
        [id]="id + '-option-' + index"
        class="sh-checkbox sh-form-check__input sh-form-group__input"
        [checked]="isSet(option)"
        (change)="toggleCheckbox($event, option)"
        [shIndeterminate]="isIndeterminate(option)"
        [disabled]="disabled || (!isSet(option) && option.disabled)"
        (focus)="onFocus()"
        />
      <label [for]="id + '-option-' + index" class="sh-form-check__label">{{ option.label }}</label>
    </li>
  }
</ul>
